<template>
    <div class="w-full bg-v-yellow flex md:flex-row flex-col justify-center items-center text-black text-sm font-fira font-light">
        <div class="flex flex-col items-center md:items-end p-1 m-1 w-auto lg:w-1/4 mt-4 md:mt-0">
            <a @click="$modal.show('impressum')" class="cursor-pointer no-underline uppercase text-black my-1 hover:font-medium">Impresszum</a>
            <!--<a href="#" class="no-underline uppercase text-black my-1 hover:font-medium">Általános szerződési-->
                <!--feltételek</a>-->
            <a @click="$modal.show('protection')" class="cursor-pointer no-underline uppercase text-black my-1 hover:font-medium">Adatvédelmi nyilatkozat</a>
        </div>
        <div class="mx-8 divider self-center md:block hidden">
        </div>
        <div class="flex flex-row justify-start lg:w-1/3 w-auto my-6">
            <div class="flex flex-col items-center">
                <div class="mb-4">
                    <a href="http://www.facebook.com/visualzhu" target="_blank"><img class="cursor-pointer w-10 mx-4" src="../assets/icons/facebook.png" alt=""></a>
                    <a href="http://www.instagram.com/visualzhu" target="_blank"><img class="cursor-pointer w-10 mx-4" src="../assets/icons/instagram.png" alt=""></a>
                    <a href="http://www.twitter.com/visualzhu" target="_blank"><img class="cursor-pointer w-10 mx-4" src="../assets/icons/twitter.png" alt=""></a>
                    <a href="http://www.linkedin.com/company/visualzhu" target="_blank"><img class="cursor-pointer w-10 mx-4" src="../assets/icons/linkedin.png" alt=""></a>
                </div>
                <span class="mb-4">Kövess minket közösségi oldalainkon!</span>
                <span class="">© 2018 | VISUALZ Webdesign & Branding Stúdió Kft</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped>
    a:visited {
        color: black;
    }

    .divider {
        height: 110px;
        border-left: 1px solid white;
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue